const team = [
  {
    name: 'Алексей Горбунов',
    role: 'Генеральный директор',
    exp: 'В фармацевтике с 2005 года',
    desc: 'Основатель сети. Под его руководством Горздрав вырос из одной аптеки в федеральную сеть с более чем 1 000 точек.',
    color: '#ff2d78',
    image: 'https://public.readdy.ai/ai/img_res/180376c47aaee2e490500e0e76b304aa.jpg',
  },
  {
    name: 'Марина Соколова',
    role: 'Главный фармацевт',
    exp: 'Провизор высшей категории',
    desc: 'Отвечает за качество и безопасность всего ассортимента. Кандидат фармацевтических наук, автор 12 научных публикаций.',
    color: '#00f5ff',
    image: 'https://readdy.ai/api/search-image?query=professional%20female%20pharmacist%20portrait%20white%20coat%20confident%20smile%20clean%20studio%20background%20medical%20specialist%20headshot&width=300&height=300&seq=team2&orientation=squarish',
  },
  {
    name: 'Дмитрий Волков',
    role: 'Директор по технологиям',
    exp: 'IT-директор с 2016 года',
    desc: 'Создал цифровую платформу Горздрав с нуля. Под его руководством запущено мобильное приложение с 1 млн+ пользователей.',
    color: '#39ff14',
    image: 'https://readdy.ai/api/search-image?query=professional%20male%20CTO%20technology%20director%20portrait%20business%20casual%20confident%20smile%20clean%20studio%20background%20corporate%20headshot&width=300&height=300&seq=team3&orientation=squarish',
  },
  {
    name: 'Ольга Петрова',
    role: 'Директор по развитию',
    exp: 'В компании с 2012 года',
    desc: 'Руководит региональной экспансией. Открыла более 400 новых аптек в 40 регионах России за последние 5 лет.',
    color: '#f0ff00',
    image: 'https://readdy.ai/api/search-image?query=professional%20female%20business%20development%20director%20portrait%20business%20suit%20confident%20smile%20clean%20studio%20background%20corporate%20headshot&width=300&height=300&seq=team4&orientation=squarish',
  },
  {
    name: 'Сергей Новиков',
    role: 'Финансовый директор',
    exp: 'CFO с 2014 года',
    desc: 'Обеспечивает финансовую устойчивость компании. Под его руководством выручка выросла в 8 раз за 10 лет.',
    color: '#ff6b00',
    image: 'https://readdy.ai/api/search-image?query=professional%20male%20CFO%20finance%20director%20portrait%20business%20suit%20confident%20smile%20clean%20studio%20background%20corporate%20headshot&width=300&height=300&seq=team5&orientation=squarish',
  },
  {
    name: 'Татьяна Золина',
    role: 'Ответственный провизор',
    exp: 'Провизор, стаж с 2009 года',
    desc: 'Ответственное лицо за размещение информации о лекарственных препаратах. Образование: СГМУ им. В.И. Разумовского.',
    color: '#ff2d78',
    image: 'https://readdy.ai/api/search-image?query=professional%20female%20pharmacist%20specialist%20portrait%20white%20coat%20friendly%20smile%20clean%20studio%20background%20medical%20headshot&width=300&height=300&seq=team6&orientation=squarish',
  },
];

const AboutTeam = () => (
  <section className="px-6 lg:px-12 pb-24 relative" style={{ background: 'rgba(255,255,255,0.01)' }}>
    <div className="max-w-7xl mx-auto">
      {/* Section header */}
      <div className="mb-14">
        <p className="font-mono text-xs tracking-[0.3em] text-neon-cyan/60 mb-2">НАША КОМАНДА</p>
        <h2 className="font-orbitron font-black text-3xl md:text-4xl text-white">
          ЛЮДИ, КОТОРЫЕ<br />
          <span style={{ color: '#00f5ff', textShadow: '0 0 20px #00f5ff60' }}>ДЕЛАЮТ ГОРЗДРАВ</span>
        </h2>
        <div className="mt-3 w-16 h-0.5" style={{ background: 'linear-gradient(90deg, #00f5ff, transparent)' }} />
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {team.map((member) => (
          <div
            key={member.name}
            className="card-cyber rounded-2xl overflow-hidden group transition-all duration-300"
            style={{ borderColor: `${member.color}20` }}
          >
            {/* Photo */}
            <div
              className="relative h-52 overflow-hidden"
              style={{ background: `linear-gradient(135deg, #0a0a14 0%, ${member.color}08 100%)` }}
            >
              <img
                src={member.image}
                alt={member.name}
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#050508] via-transparent to-transparent" />
              {/* Color accent top */}
              <div
                className="absolute top-0 left-0 right-0 h-0.5"
                style={{ background: `linear-gradient(90deg, transparent, ${member.color}, transparent)` }}
              />
            </div>

            {/* Info */}
            <div className="p-5">
              <div className="flex items-start justify-between mb-1">
                <h3 className="font-orbitron font-bold text-sm text-white">{member.name}</h3>
                <div
                  className="w-2 h-2 rounded-full shrink-0 mt-1.5"
                  style={{ background: member.color, boxShadow: `0 0 8px ${member.color}` }}
                />
              </div>
              <p
                className="font-mono text-xs mb-0.5"
                style={{ color: member.color }}
              >
                {member.role}
              </p>
              <p className="font-mono text-xs text-white/30 mb-3">{member.exp}</p>
              <p className="font-mono text-xs text-white/40 leading-relaxed">{member.desc}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default AboutTeam;
